import { createSelector } from 'reselect';

const getPicking = (store) => {
  return store.picking;
};

const getPicksByWoo = createSelector([getPicking], (picking) => {
  return picking.picksByWoo;
});

// The picks with the given status, keyed by WOO. WOOs with none are omitted.
const picksWithStatusByWoo = (status) => {
  return createSelector([getPicksByWoo], (picksByWoo) => {
    return Object.keys(picksByWoo).reduce((memo, wooId) => {
      const picks = picksByWoo[wooId].filter((pick) => {
        return pick.status === status;
      });
      return picks.length ? { ...memo, [wooId]: picks } : memo;
    }, {});
  });
};

// Picks made at job start that wait for their start to be confirmed.
const getStagedPicksByWoo = picksWithStatusByWoo('staged');

// Staged picks whose start is confirmed and that are being written.
const getWritingPicksByWoo = picksWithStatusByWoo('writing');

// For each WOO with staged picks, the startRef (see getConfirmedRunningStart) of the
// start that was already running that WOO when the picks were staged, or null.
const getStagedBaselineByWoo = createSelector([getPicking], (picking) => {
  return picking.stagedBaselineByWoo || {};
});

export {
  getPicking,
  getPicksByWoo,
  getStagedPicksByWoo,
  getWritingPicksByWoo,
  getStagedBaselineByWoo,
};
